export const generateRandomTransId = () => Math.floor(100000 + Math.random() * 900000)